import { useConfig } from "../contexts/ConfigContext"
import { contentPath, modules } from "../config/pages"
import React, { useEffect, useState } from "react"
import { AppstoreOutlined, RobotOutlined, ToolOutlined, TeamOutlined, MessageOutlined } from "@ant-design/icons"
import { useHistory } from "react-router-dom"
import { ItemType } from "antd/es/menu/interface"
import { useUser } from "../contexts/UserContext"
import { SideBar as SharedSideBar } from "@ryo/ui"

const botOptions = [
  {key: modules.BotList, label:"Bots", icon: <RobotOutlined />},
  {key: modules.ToolList, label:"Herramientas", icon: <ToolOutlined />},
  {key: modules.ContactList, label:"Contactos", icon: <TeamOutlined />},
  {key: modules.ChatList, label:"Conversaciones", icon: <MessageOutlined />},
]

function getMenuItems(permissions:any){
  const views = permissions.views || []
  
  const availableOptions = botOptions.filter(el => views.join().includes(el.key.toLowerCase()))

  const menuItems: any[] = []
  if(availableOptions.length){
    menuItems.push({
      key: "wpbot",
      icon: <AppstoreOutlined />,
      label: "WhatsApp Bot",
      children: availableOptions
    })
  }
  return menuItems
}

const getParentKey = (key: string,menuItems:ItemType[]) => {
  const parent = menuItems.find(item => 
    item && "children" in item && Array.isArray((item as any).children) &&
    (item as any).children.some((child: any) => child.key === key)
  );
  return parent?.key?.toString() ?? null;
};

function SideBar(props:any){
  const history = useHistory()
  const {config,updateConfig} = useConfig()
  const {user} = useUser()
  const menuItems = React.useMemo(() => getMenuItems(user.permissions), [user.permissions]);
  const [openKey, setOpenKey] = useState<string | null>(getParentKey(config.module,menuItems as any));
  const lastModuleRef = React.useRef(config.module);

  useEffect(() => {
    if (lastModuleRef.current !== config.module) {
        lastModuleRef.current = config.module;
        setOpenKey(getParentKey(config.module, menuItems as any));
    }
  }, [config.module, menuItems]);

  const handleOpenChange = (keys: string[]) => {
    setOpenKey(keys.length > 0 ? keys.at(-1) || null : null);
  };

  const toggleCollapsed = () => {
    updateConfig({sideCollapsed:!config.sideCollapsed})
  };

  const handleSelected = (key: string) => {
    const moduleSelectedKey = Object.keys(modules).find(k => modules[k as keyof typeof modules] === key)
    const module = modules[moduleSelectedKey as keyof typeof modules]
    updateConfig({module});
    history.push(contentPath[module as keyof typeof contentPath].replace(":id",""))
  }

  return(
    <SharedSideBar 
      activeKey={config.module}
      collapsed={config.sideCollapsed}
      isMobile={config.isMobile}
      menuItems={menuItems}
      openKey={openKey}
      onToggle={toggleCollapsed}
      onSelect={handleSelected}
      onOpenChange={handleOpenChange}
      title="Ryo WhatsApp Bot"
      logoSrc="/assets/images/industrial-robot.png"
    />
  )
}

export default SideBar
